// 表格下载url
// export const xmlUrl = 'https://download.ztfzex.vip/'
export const xmlUrl = 'https://down.hrqt.top/'
